module.exports = __webpack_public_path__ + "media/crohn s disease.606f1a1f.wav";